export type SessionSource = 'amplify' | 'handoff' | null;
export type SessionChange = 'lost';
export type SessionChangeListener = (change: SessionChange, of: Exclude<SessionSource, null>) => void;

let source: SessionSource = null;
const listeners = new Set<SessionChangeListener>();

export function getSessionSource(): SessionSource {
  return source;
}

export function setSessionSource(next: SessionSource): void {
  source = next;
}

export function subscribeSessionChange(listener: SessionChangeListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifySessionChange(change: SessionChange, of: Exclude<SessionSource, null>): void {
  for (const listener of Array.from(listeners)) listener(change, of);
}
